import { render, staticRenderFns } from "./FoodView.vue?vue&type=template&id=0c5e5bfa&scoped=true&"
import script from "./FoodView.vue?vue&type=script&lang=js&"
export * from "./FoodView.vue?vue&type=script&lang=js&"
import style0 from "./FoodView.vue?vue&type=style&index=0&id=0c5e5bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e5bfa",
  null
  
)

export default component.exports